import { AxiosError } from 'axios';
import { Reducer, ReducersMapObject, combineReducers } from 'redux';
import { ActionType, getType } from 'typesafe-actions';

import { RequestStatus } from '../../types/models';
import { apiActions } from '././api.actions';

export type ApiCall = {
  status: RequestStatus;
  error?: AxiosError | Error;
};

const apiCallInit: ApiCall = {
  status: RequestStatus.NONE,
};

export type AsyncAction = ActionType<typeof apiActions>;
type AsyncActionReducer = Reducer<ApiCall, ActionType<typeof apiActions>>;
type AsyncActionKey = keyof typeof apiActions;

export type ApiState = Record<AsyncActionKey, ApiCall>;

export const apiActionKeys = Object.keys(apiActions) as Array<AsyncActionKey>;

export const asyncActionReducer = (key: AsyncActionKey): AsyncActionReducer => {
  return (state: ApiCall = apiCallInit, action: AsyncAction) => {
    switch (action.type) {
      case getType(apiActions[key].request):
        return {
          status: RequestStatus.FETCHING,
        };
      case getType(apiActions[key].success):
        return {
          status: RequestStatus.SUCCESS,
        };
      case getType(apiActions[key].failure):
        return {
          status: RequestStatus.FAILURE,
          error: action.payload,
        };
      default:
        return state;
    }
  };
};

const asyncReducers: ReducersMapObject = apiActionKeys.reduce((acc, key) => {
  return {
    ...acc,
    [key]: asyncActionReducer(key),
  };
}, {});

export const api: Reducer<ApiState, AsyncAction> = combineReducers(
  asyncReducers
);
